import FolderChange from 'owa-service/lib/contract/FolderChange';
import UpdateFolderResponse from 'owa-service/lib/contract/UpdateFolderResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { trace } from 'owa-trace';
import updateFolderOperation from 'owa-service/lib/operation/updateFolderOperation';
import updateFolderRequest from 'owa-service/lib/factory/updateFolderRequest';

/**
 * Makes a call to server to save calendar sharing configuration from settings pane.
 * @folderChanges: contains updates made to the shared calendar notification settings.
 */
export default function saveCalendarSharingConfiguration(
    folderChanges: FolderChange[]
): Promise<UpdateFolderResponse> {
    return updateFolderOperation({
        Header: getJsonRequestHeader(),
        Body: updateFolderRequest({
            FolderChanges: folderChanges,
        }),
    })
        .then(response => {
            if (
                response &&
                response.Body &&
                response.Body.ResponseMessages &&
                response.Body.ResponseMessages.Items &&
                response.Body.ResponseMessages.Items.length &&
                response.Body.ResponseMessages.Items[0].ResponseClass == 'Success'
            ) {
                return response.Body;
            } else {
                return null;
            }
        })
        .catch(error => {
            trace.warn('saveCalendarSharingConfiguration is failing with error: ' + error);
            return Promise.resolve(null);
        });
}
